import { listBuiltinAgentsRegistryEntries } from "./agents/registry-source";
import { formatWakeLoopCliLine } from "./runtime/cli-entry-command";

const DEFAULT_AGENT_EXAMPLE_ID = resolveAgentExampleIds(1)[0] ?? "<agent-id>";
export const DEFAULT_AGENT_EXAMPLE_PAIR =
  resolveAgentExampleIds(2).join(" ") || "<agent-a> <agent-b>";
const TOP_LEVEL_HELP_EXAMPLES = [
  "wakeloop start",
  "wakeloop setup",
  "wakeloop auth login",
  "wakeloop login",
  "wakeloop repair local-state",
  "wakeloop uninstall",
  "wakeloop reset",
  "wakeloop upgrade",
  "wakeloop prompt",
  "wakeloop prompt onboarding",
  "wakeloop prompt commands --raw",
  "wakeloop skills",
  "wakeloop skills ensure --all",
  "wakeloop skills install --all",
  `wakeloop skills uninstall --agent ${DEFAULT_AGENT_EXAMPLE_ID}`,
  "wakeloop skills list",
  "wakeloop skills check",
  "wakeloop skills update",
  "wakeloop agents",
  "wakeloop agents detect",
  "wakeloop setup --profile <agent-profile-id>",
  "wakeloop setup --start-session <opaque-token>",
  "wakeloop agents enable --all",
  `wakeloop agents disable --agent ${DEFAULT_AGENT_EXAMPLE_ID}`,
  "wakeloop agents list",
  "wakeloop computer list",
  "wakeloop computer current",
  'wakeloop computer rename "Office MacBook"',
  "wakeloop computer rename --clear",
  "wakeloop service",
  "wakeloop service start",
  "wakeloop service status",
  "wakeloop service install",
  "wakeloop service repair",
  "wakeloop service update",
  "wakeloop service uninstall",
  "wakeloop space",
  "wakeloop space join <space-id>",
  "wakeloop space watch <space-id>",
  "wakeloop space contract <space-id>",
  "wakeloop space contract set <space-id> --dispatch-policy mention_only",
  "wakeloop space publication set <space-id> collaboration --password <value>",
  "wakeloop space status <space-id>",
  "wakeloop space updates <space-id> --after-signal <signal-id>",
  "wakeloop space result <space-id> --dispatch <dispatch-id>",
  "wakeloop space guide <space-id>",
  'wakeloop space guide set <space-id> "Keep replies concise."',
  "wakeloop space guide clear <space-id>",
  "wakeloop space join <space-id> --password <value>",
  "wakeloop space password <space-id> --password <new-password>",
  'wakeloop space send <space-id> "hello from Mars deck"',
  'echo "hello from file-safe input" | wakeloop space send <space-id> --stdin',
  "wakeloop space send <space-id> --file /tmp/message.txt",
  "wakeloop view",
  "wakeloop view agent",
] as const;

const TOP_LEVEL_HELP_GET_OPTIONS_EXAMPLES = [
  "wakeloop <command> --help",
  "wakeloop space --help",
  "wakeloop space join --help",
  "wakeloop skills --help",
  "wakeloop agents --help",
  "wakeloop computer --help",
] as const;

export function buildTopLevelHelpText(): string {
  const exampleLines = TOP_LEVEL_HELP_EXAMPLES.map((line) => {
    return `  ${formatWakeLoopCliLine(line)}`;
  });
  const getOptionsLines = TOP_LEVEL_HELP_GET_OPTIONS_EXAMPLES.map((line) => {
    return `  ${formatWakeLoopCliLine(line)}`;
  });
  return [
    "",
    "Examples:",
    ...exampleLines,
    "",
    "Get command options:",
    ...getOptionsLines,
    "",
  ].join("\n");
}

export function buildCommandHelpExamples(
  title: string,
  examples: string[]
): string {
  const lines = examples.map((line) => `  ${formatWakeLoopCliLine(line)}`);
  return ["", `${title}:`, ...lines, ""].join("\n");
}

function resolveAgentExampleIds(limit: number): string[] {
  const normalizedLimit = Number.isFinite(limit) ? Math.max(1, limit) : 1;
  try {
    const installableBuiltinIds = listBuiltinAgentsRegistryEntries()
      .filter((agent) => agent.service.skillsInstallable === true)
      .map((agent) => agent.id);
    return installableBuiltinIds.slice(0, normalizedLimit);
  } catch {
    return [];
  }
}
